"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const emotion_1 = require("emotion");
const utils_1 = require("./utils");
class Label extends react_1.PureComponent {
    render() {
        const _a = this.props, { className, type, status, size, text } = _a, rest = __rest(_a, ["className", "type", "status", "size", "text"]);
        return (react_1.default.createElement("span", Object.assign({ className: emotion_1.cx('label', `label-${status || type || 'default'}`, { [`label-${size}`]: size }, className) }, rest), text));
    }
}
exports.default = Label;
Label.propTypes = {
    status: prop_types_1.default.oneOf(['default', 'primary', 'success', 'warning', 'danger', 'info']),
    size: prop_types_1.default.oneOf(['sm', 'lg']),
    text: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    type: utils_1.deprecatedProp(prop_types_1.default.oneOf(['default', 'primary', 'success', 'warning', 'danger', 'info']), 'Use `status` instead.'),
};
